import script from "./AddCategoryForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddCategoryForm.vue?vue&type=script&lang=ts&setup=true"

import "./AddCategoryForm.vue?vue&type=style&index=0&id=f7166246&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7166246"]])

export default __exports__